<div>
  <div *ngFor="let window of dynamicWindows">
  </div>
</div>
<ng-template dynamic-windows>    </ng-template>
